import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=4512c6df&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"
import style0 from "./ranking.vue?vue&type=style&index=0&id=4512c6df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4512c6df",
  null
  
)

export default component.exports